export default __webpack_public_path__ + "static/media/sunsculpted2.f67d060e.jpg";